export const PRO_TOOLTIP = "Part of Ikavio Pro — every new member gets a 7-day full Pro trial";

export const ProBadge = ({ testId = "pro-badge", className = "" }) => (
  <span
    data-testid={testId}
    title={PRO_TOOLTIP}
    className={`inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-bold tracking-wider uppercase text-white select-none ${className}`}
    style={{ background: "linear-gradient(90deg, #14B393 0%, #2E7CF6 55%, #8B7CF6 100%)" }}
  >
    Pro
  </span>
);
